import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import { IControlViewModelConstructorParameter } from '#/CoreFrameInterfaces';
import SplitterPaneViewModel from '@/ViewModels/Controls/SplitterPaneViewModel';

interface ISplitterPaneDividerViewModelParams extends IControlViewModelConstructorParameter {
    attachedTo: SplitterPaneViewModel;
}

type ResizeStartHandler = () => void;
type ResizeEndHandler = () => void;

export default class SplitterPaneDividerViewModel extends ControlViewModel {
    public attachedTo: SplitterPaneViewModel;

    public isMovable: KnockoutObservable<boolean>;
    public isClickable: KnockoutObservable<boolean>;
    public isCollapsed: KnockoutObservable<boolean>;

    private resizeStartHandlers: ResizeStartHandler[] = [];
    private resizeEndHandlers: ResizeEndHandler[] = [];

    constructor(params: ISplitterPaneDividerViewModelParams) {
        super(params);

        this.attachedTo = params.attachedTo;
        this.isVisible = params.isVisible ? this.observableOrDefault(params.isVisible) : this.defineComputed(() => {
            const paneIsVisible = this.attachedTo.isVisible();
            const paneIsExpanded = this.attachedTo.isExpanded();
            const paneIsCollapsible = this.attachedTo.isCollapsible();
            return paneIsVisible && (paneIsExpanded || paneIsCollapsible);
        });
        this.isMovable = this.defineComputed(() => {
            const paneIsEnabled = this.attachedTo.isEnabled();
            const paneIsResizable = this.attachedTo.isResizable();
            const paneIsExpanded = this.attachedTo.isExpanded();
            return paneIsEnabled && paneIsResizable && paneIsExpanded;
        });
        this.isClickable = this.attachedTo.isCollapsible;
        this.isCollapsed = this.defineComputed(() => !this.attachedTo.isExpanded());
        this.resizeStartHandlers = [];
        this.resizeEndHandlers = [];
    }

    public registerResizeStartHandler(handler: ResizeStartHandler) {
        this.resizeStartHandlers.push(handler);
    }

    public registerResizeEndHandler(handler: ResizeEndHandler) {
        this.resizeEndHandlers.push(handler);
    }

    public triggerResizeStart() {
        for (const handler of this.resizeStartHandlers)
            handler();
    }

    public triggerResizeEnd() {
        for (const handler of this.resizeEndHandlers)
            handler();
    }

    public onClick() {
        if (!this.isEnabled() || !this.isClickable())
            return;

        this.attachedTo.isExpanded(!this.attachedTo.isExpanded());
    }
}

ComponentManager.setViewModel('SplitterPaneDividerViewModel', SplitterPaneDividerViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');